import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { StudentDetailPage } from '../student-detail/student-detail.page';

@Component({
  selector: 'app-students',
  templateUrl: './students.page.html',
  styleUrls: ['./students.page.scss'],
})
export class StudentsPage implements OnInit {

  constructor(private modalCtrl:ModalController, private navCtrl:NavController) { }

  ngOnInit() {
  }

  async modalStudent() {
    const modal = await this.modalCtrl.create({
      component: StudentDetailPage,
    });
    return await modal.present();
  }

}
